export const PlacesOutageMessage = "itjz9d";
export default {PlacesOutageMessage};